var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFridge = function SvgIconFridge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 787.51 1199.97",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M714.38 0H71.93C31.01 0 0 27.04 0 67.99v306.98l787.5-1.61V74.4c0-40.91-32.14-74.4-73.12-74.4ZM150 225c0 20.7-16.8 37.5-37.5 37.5S75 245.7 75 225v-75c0-20.7 16.8-37.5 37.5-37.5S150 129.3 150 150v75ZM0 1122.2c0 40.84 31.01 77.77 71.93 77.77h640.65c40.99 0 74.93-36.94 74.93-77.77V449.97H0v672.23Zm75-559.73c0-20.7 16.8-37.5 37.5-37.5s37.5 16.8 37.5 37.5v225c0 20.74-16.8 37.5-37.5 37.5S75 808.21 75 787.47v-225Z"
  })));
};
export default SvgIconFridge;